// Vendor Libraries
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {get} from 'lodash';

// Components
import Permissions from '../core/permissions';
import SearchRecordDetails from '../app/search-record-details';
import Thumbnail from '../core/thumbnail';

// Containers
import withSearch from '../../containers/with-search';

// Styles
import './network-detail.scss';

const servicesDataKey = 'networkDetail';

class NetworkDetail extends Component {
    getSearchRecordDetailProps() {
        return {
            ...this.props,
            servicesDataKey,
            keyOrder: 'networks',
        };
    }

    renderImage() {
        const {searchData} = this.props;
        const image = get(searchData, '0.image');

        return image ? (
            <div className="network-detail--column-left">
                <Thumbnail
                    className="network-detail--thumbnail"
                    height={image.imageHeight}
                    key={image.imageId}
                    src={image.finalResourceName}
                    width={image.width}
                />
            </div>
        ) : null;
    }

    render() {
        return (
            <Permissions
                accessRequirement="read"
                elementService="network"
                notAuthorizedMessage={true}
                requiresServiceAccess={true}
            >
                <div className="network-detail">
                    {this.renderImage()}
                    <SearchRecordDetails {...this.getSearchRecordDetailProps()} />
                </div>
            </Permissions>
        );
    }
}

NetworkDetail.propTypes = {
    searchData: PropTypes.array.isRequired,
};

export default withSearch(NetworkDetail, servicesDataKey);
